import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/jobs.json";

export const useJobs = ({ sectors = null, locations = null, limit = 8 } = {}) => {
  let collection = useSourceFlowCollection(data.jobs);

  if (sectors && sectors.length > 0) {
    collection = collection.filter((job) => job?.categories.find((cat) => cat.id === "54182828-5365-45cf-ac98-4f86ec1177cd")?.values.some((filter) => sectors?.includes(filter.id)));
  }
  
  if (locations && locations.length > 0) {
    collection = collection.filter((job) => job?.categories.find((cat) => cat.id === "3259bf19-6cd5-41c8-81cc-5217e80df31c")?.values.some((filter) => locations?.includes(filter.id)));
  }

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useJobs;
